import { GenericTable } from "@shared/components/GenericTable";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

import { ArrowRight, Eye } from "lucide-react";
import { useMeterRunList, useValidationIssues } from "../../hooks";

type Issue = {
  reading_id: string;
  meter_id: string;
  customer: string;
  issue: string;
  severity?: "high" | "medium" | "low";
  date: string;
};

export const IssuesTable = ({validationIssues}) => {
  const remoteUtilityId = getRemoteUtilityId();
  // const { data: issueData } = useValidationIssues({
  //   remote_utility_id: remoteUtilityId,
  // });
  const issueData = validationIssues;
  // Transform API data to match the table structure
  const issues: Issue[] = issueData?.results || [];

  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case "high":
        return "bg-red-100 text-red-800 hover:bg-red-200";
      case "medium":
        return "bg-orange-100 text-orange-800 hover:bg-orange-200";
      case "low":
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
    }
  };

  const columns = [
    {
      key: "readingId",
      header: "Reading ID",
      width: "w-[120px]",
    },
    {
      key: "meterId",
      header: "Meter ID",
      width: "w-[100px]",
    },
    {
      key: "customer",
      header: "Customer",
      responsive: { hidden: "md:table-cell" },
    },
    {
      key: "issue",
      header: "Issue",
      render: (value: string, row: Issue) => (
        <Badge
          variant="outline"
          className={getSeverityColor(row.severity || "medium")}
        >
          {value}
        </Badge>
      ),
    },
    {
      key: "date",
      header: "Date",
      responsive: { hidden: "sm:table-cell" },
    },
    {
      key: "actions",
      type: "actions" as const,
      header: "Action",
      actions: [
        {
          label: "View",
          icon: "Eye",
          onClick: (row: Issue) => console.log("View", row),
          variant: "ghost",
        },
      ],
      actionsType: "icons", // or "buttons" if you prefer
    },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 border border-border">
      <div className="flex justify-between items-center mb-4">
        <h2 className="page-subheading">Recent Validation Issues</h2>
        <p className="text-sm text-muted-foreground">
          Meter readings requiring attention in the last 7 days
        </p>
      </div>
      <div className="rounded-lg border overflow-hidden">
        <GenericTable
          data={issues}
          columns={columns}
          rowKey="reading_id"
          emptyMessage="No issues found"
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </div>
      {/* <div className="flex justify-end mt-4">
        <Button variant="link" className="text-primary">
          View All Issues <ArrowRight className="h-4 w-4 ml-1" />
        </Button>
      </div> */}
    </div>
  );
};
